export default __webpack_public_path__ + "static/media/icon_6.93be0491.png";